import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import { Input } from '../../../../UI/Common';

const ViewLicensePage = ({ t, info, ...props }) => {
  if (props.invalidId) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This department is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  function getServiceAccount() {
    if (!Array.isArray(info.serviceAccount)) {
      return '';
    }
    return info.serviceAccount.join(', ');
  }
  return (
    <Backend title={`View License for Department: ${props.dept.name}`}>
      <div className="content-inner">
        <div className="row">
          <div className="col">
            <Item label="Department Name" value={info.departmentName} />
            <Item label="Creation Date" value={info.creationDate} />
            <Item label="Expiration Time" value={info.expirationTime} />
            <Item label="Sensor Count" value={info.sensorCount} />
            <Item label="User Count" value={info.userCount} />
            <Item
              type="textarea"
              inputClass="custom-text-area"
              label="Service Accounts"
              value={getServiceAccount()}
            />
          </div>
          <div className="col"></div>
        </div>
      </div>
    </Backend>
  );
};

const Item = (props) => <Input readOnly disabled {...props} />;

export default withTranslation('app')(ViewLicensePage);
